import PageHeaderComponents from './page-header.vue';

const PageHeader = {
    install(Vue) {
        Vue.component('PageHeader', PageHeaderComponents);
    }
};

export {
    PageHeader
};
